import countries from "i18n-iso-countries";
import fi from "i18n-iso-countries/langs/fi.json";
import en from "i18n-iso-countries/langs/en.json";

countries.registerLocale(fi);
countries.registerLocale(en);

export const getKansalaisuusOptions = (language: string = "fi") => {
  // Get alpha-3 codes and convert to alpha-2 to get the name
  const alpha3Codes = Object.keys(countries.getAlpha3Codes());

  return alpha3Codes
    .map((alpha3) => {
      const alpha2 = countries.alpha3ToAlpha2(alpha3);
      const name = countries.getName(alpha2 || "", language);
      return {
        label: `${name} (${alpha3})`, // ← Show alpha-3 code
        value: alpha3, // ← Use alpha-3 as value
      };
    })
    .sort((a, b) => a.label.localeCompare(b.label));
};

// Convert alpha-3 to alpha-2
export const alpha3ToAlpha2 = (alpha3: string): string => {
  const alpha2 = countries.alpha3ToAlpha2(alpha3);
  return alpha2 || alpha3; // fallback to original if conversion fails
};

export const alpha2ToAlpha3 = (alpha2: string): string => {
  const alpha3 = countries.alpha2ToAlpha3(alpha2);
  return alpha3 || alpha2;
};
